import { EventEmitter } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { GroupService } from '../../../services/group-details/group.service';
import { AddPostToProject } from '../../../../models/influencer';
import { Project } from '../../../../models/project/project';
import { ActionSource } from '../../../services/event-tracker/event-tracker.service';
import { ActivePage } from '../../../../models/event-tracker';
var AddPostsToProjectComponent = /** @class */ (function () {
    function AddPostsToProjectComponent(groupService, userService) {
        this.groupService = groupService;
        this.userService = userService;
        this.backToPreviewInfluencerEvent = new EventEmitter();
        this.addPostsToProjectExecution = new EventEmitter();
        this.createNewProjectEvent = new EventEmitter();
        this.projectList = [];
        this.isShowSummarize = false;
        this.numberSelectedPost = 1;
        this.postAddToProject = new AddPostToProject();
    }
    AddPostsToProjectComponent.prototype.addPostsToProject = function () {
        this.addPostsToProjectExecution.emit(this.postAddToProject);
    };
    AddPostsToProjectComponent.prototype.onSelectProject = function (project) {
        this.selectedProject = new Project();
        this.selectedProject.keywords = project.keywords;
        this.selectedProject.countries = project.countries;
        this.postAddToProject.projectName = project.name;
        this.postAddToProject.projectId = project.id;
    };
    AddPostsToProjectComponent.prototype.backToPreviewInfluencer = function () {
        this.backToPreviewInfluencerEvent.emit();
    };
    AddPostsToProjectComponent.prototype.createNewProject = function () {
        this.createNewProjectEvent.emit();
    };
    Object.defineProperty(AddPostsToProjectComponent.prototype, "actionSource", {
        get: function () {
            return ActionSource.ACTION_VIEW;
        },
        enumerable: true,
        configurable: true
    });
    return AddPostsToProjectComponent;
}());
export { AddPostsToProjectComponent };



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/add-posts-to-project/add-posts-to-project.component.ts.pre-build-optimizer.js